var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","color":"green white--text text-capitalize subtitle-1 mt-2"},on:{"click":_vm.signUpWithGoogle}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("mdi-google")]),_vm._v(" Login using gmail ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }